export function setLocStorageOpenItemsInNewTab(value: boolean): void {
  localStorage.setItem("openItemsInNewTab", value ? "true" : "false");
}

export function getLocStorageOpenItemsInNewTab(): boolean {
  const value = localStorage.getItem("openItemsInNewTab");
  return value === "true";
}

export function setLocStorageSignupEmail(email: string): void {
  localStorage.setItem("signupEmail", email);
}

export function getLocStorageSignupEmail(): string | null {
  return localStorage.getItem("signupEmail");
}

export function setSesStorageCartType(value: "auction" | "bids") {
  sessionStorage.setItem("cartType", value);
}

export function getSesStorageCartType(): "auction" | "bids" | null {
  const value = sessionStorage.getItem("cartType");
  return value === "auction" ? "auction" : value === "bids" ? "bids" : null;
}

export function removeSesStorageCartType() {
  sessionStorage.removeItem("cartType");
}
